import { useEffect, useState } from 'react';

/**
 * A consulta de mídia vale agora? Acompanha as mudanças (girar o celular, redimensionar). Sem matchMedia
 * (testes), vale o padrão informado.
 */
export function useMediaQuery(query: string, fallback = true): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia?.(query).matches ?? fallback);
  useEffect(() => {
    const media = window.matchMedia?.(query);
    if (!media) return;
    const onChange = () => setMatches(media.matches);
    onChange();
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}
